import { useQuery } from '@tanstack/react-query';
import { fetchStartupSharePreview } from '../api/startup-profile.api';

/**
 * The founder's preview of their profile as a share-link recipient sees it.
 *
 * Never served from cache (`staleTime`/`gcTime` 0, overriding the app's 60s
 * default): the founder typically edits and then previews, and a cached copy
 * from a minute ago would show them a profile that is no longer the one they
 * are about to share.
 */
export function useStartupSharePreview(entityId: string) {
  return useQuery({
    queryKey: ['startup', entityId, 'share-preview'],
    queryFn: () => fetchStartupSharePreview(entityId),
    staleTime: 0,
    gcTime: 0,
  });
}
